import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetStartedComponent } from './get-started.component';
import { GetStartedFormModule } from 'src/app/components/get-started-form/get-started-form.module';
import { SeoServiceService } from '@xref/ngx';

@NgModule({
  imports: [
    CommonModule,
    GetStartedFormModule
  ],
  declarations: [GetStartedComponent],
  providers: [SeoServiceService]
})
export class GetStartedModule {}
